import { ErrorHandler, Injectable, inject } from '@angular/core';

import { ApLoggingService } from '@ap/logging';

import { ApErrorService } from './error.service';
import { ApError } from './error';

/**
 * @ngdoc service
 * @name ApErrorHandlerService
 * @module ApErrorModule
 *
 * @description
 * A generic error handler that will catch any error thrown and uses the `ApErrorService` to make the error reactive.
 **/
@Injectable()
export class ApErrorHandlerService implements ErrorHandler {
    private readonly loggingService = inject(ApLoggingService);
    private readonly errorService = inject(ApErrorService);

    public handleError(error: any): void {
        // Very temporary workaround to supress Zone error
        if (error.code === 909) {
            return;
        }
        if (error instanceof ApError) {
            this.loggingService.error(`ApErrorHandlerService for context '${error.context}':`, error);
            if (error.cause) {
                this.loggingService.error('ApErrorHandlerService cause:', error.cause);
            }
            this.errorService.publish(error);
        } else {
            this.loggingService.error('ApErrorHandlerService:', error);
        }
    }
}
